export default __webpack_public_path__ + "static/media/butcher6.603e0e73.png";